
export const SET_STEP = 'importRequest/SET_STEP';
export const setCurrentStep = currentStep => ({
  type: SET_STEP,
  currentStep
});
